import { render, staticRenderFns } from "./safetyCheckTab.vue?vue&type=template&id=a2f86fbe"
import script from "./safetyCheckTab.vue?vue&type=script&lang=js"
export * from "./safetyCheckTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2f86fbe')) {
      api.createRecord('a2f86fbe', component.options)
    } else {
      api.reload('a2f86fbe', component.options)
    }
    module.hot.accept("./safetyCheckTab.vue?vue&type=template&id=a2f86fbe", function () {
      api.rerender('a2f86fbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/mim/smd/safetyCheckTab.vue"
export default component.exports